import React, { createContext, useState, useEffect } from "react";
import en from "../translations/en.json";
import ku from "../translations/ku.json";
import ar from "../translations/ar.json";

export const LanguageContext = createContext();

const translations = {
  en,
  ku,
  ar,
};

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("currentLang") || "en";
  });

  const [texts, setTexts] = useState(translations[currentLang] || en);

  useEffect(() => {
    setTexts(translations[currentLang] || en);
    localStorage.setItem("currentLang", currentLang);

   
    if (currentLang === "ar" || currentLang === "ku") {
      document.body.dir = "rtl";
    } else {
      document.body.dir = "ltr";
    }
  }, [currentLang]);

 
  const displayName = {
    en: "English",
    ar: "Arabic",
    ku: "Kurdish",
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLang,
        setCurrentLang,
        texts,
        displayName,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
